// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"b52059d1","93":"ec942187","119":"23acbe8f","178":"3848a6cf","240":"abf8233c","381":"5f059ef1","530":"713918c1","795":"5469b39f","815":"937fc1ef"}[chunkId] + ".chunk.css";
};